export interface Gist {
  id: number,
  feedTitle: string,
  feedUrl: string,
  feedType: FeedType,
  title: string,
  author: string,
  isSponsoredContent: boolean,
  url: string,
  published: string,
  updated: string,
  summary: string,
  tags: string[]
}

export interface FeedInfo {
  id: number,
  title: string,
  rssUrl: string,
  language: string,
}

export interface SimilarGist {
  gist: Gist,
  similarity: number,
}

export interface RecapRelatedGist {
  id: number,
  title: string,
}

export interface RecapSection {
  heading: string,
  recap: string,
  related: RecapRelatedGist[],
}

export interface Recap {
  created: string,
  recapSections: RecapSection[],
  id: number,
}

export enum LanguageMode {
  ORIGINAL = "Original",
  ENGLISH = "En",
  GERMAN = "De",
}

export enum FeedType {
  News = 0,
  Blog = 1,
}
